import { Icon } from "./Icon.tsx";

/** "Land Uses" tab icon — an unevenly subdivided parcel (3 differently-sized
 * zones), distinct from LayoutGridIcon.tsx's own 4 equal squares and
 * DataIcon.tsx's own symmetric spreadsheet grid — a land-use map is
 * subdivided by real, irregular zone boundaries, not a uniform grid. */
export function LandUseIcon() {
  return (
    <Icon>
      <rect x="3" y="3" width="18" height="18" rx="1" />
      <path d="M3 14h9v7M12 3v11" />
    </Icon>
  );
}
